import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Ipms from '../../images/ipms.svg';
import { loadAsnOverviewDates } from '../../utils/tableUtils';
import { buildErrorMessage } from '../../apis/calls';
import styles from './AsnUpdatesLiveToolbar.module.css';
import LineDropdownSelector from '../LineDropdownSelector/LineDropdownSelector';
import DateSelector from '../DateSelector/DateSelector';
import AttributesSelector from '../AttributesSelector/AttributesSelector';
import { optionalColumns } from '../../staticData';

const AsnUpdatesLiveToolbar = ({
  activeDate,
  setActiveDate,
  plant,
  line,
  selectedOptionalColNames,
  handleColumnSelection,
}) => {
  const [asnDates, setAsnDates] = useState([]);

  useEffect(() => {
    setActiveDate(null);
    loadAsnOverviewDates(plant.value, line.value, setAsnDates, setActiveDate).catch(
      err => {
        console.error(buildErrorMessage(err));
      },
    );
  }, [plant.value, line.value, setActiveDate]);

  return (
    <div className={styles.toolbar}>
      <div className={styles.live} style={{ width: '10%' }}>
        <div className={styles.liveTitle}>Live Update</div>
        <div className={styles.liveDate}>{moment().format('DD MMM YYYY')}</div>
      </div>
      <div style={{ width: '50%' }}>
        <div className={styles.toolsContainer}>
          <div className={styles.detail}>
            <div>Production Broadcast</div>
            <div>ASN Overview</div>
          </div>
          <div className={styles.lineSelect}>
            <div className={styles.selectorTitle}>Select Vehicle Line</div>
            <div className={styles.selectorBt}>
              <LineDropdownSelector
                isDarkStyle={true}
                className={styles.darkDropdown}
                height={26}
              />
            </div>
          </div>
          <div className={styles.datePicker}>
            <DateSelector
              activeDate={activeDate}
              dates={asnDates}
              handleDateSelect={date => setActiveDate(date)}
              classNames={{
                activeDateButton: styles.activeDateButton,
                datesSelectorButton: styles.datesSelectorButton,
                monthName: styles.monthName,
              }}
            />
          </div>
          <AttributesSelector
            buttonClassName={styles.attributesButton}
            columns={optionalColumns}
            selectedOptionalCols={selectedOptionalColNames}
            applyColumnsSelection={handleColumnSelection}
          />
        </div>
      </div>
      <div className={styles.title} style={{ width: '35%' }}>
        <span className={styles.titleText}>Connected shop</span>
        <Link to="/" className={styles.homeLink}>
          <img src={Ipms} alt="IPMS" className={styles.ipmsLogo} />
        </Link>
      </div>
    </div>
  );
};

AsnUpdatesLiveToolbar.propTypes = {
  activeDate: PropTypes.objectOf(moment),
  setActiveDate: PropTypes.func.isRequired,
  plant: PropTypes.shape({ value: PropTypes.string }).isRequired,
  line: PropTypes.shape({ value: PropTypes.number }).isRequired,
  selectedOptionalColNames: PropTypes.arrayOf(PropTypes.string),
  handleColumnSelection: PropTypes.func.isRequired,
};

export default AsnUpdatesLiveToolbar;
